import React, { Component } from 'react';
import { Grid, Button, Select, MenuItem } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withLang } from '../../util/lang';
import { connect } from 'react-redux';

class Aligner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClickOpen() {
        this.setState({ open: true });
    }

    handleClose = () => {
        this.setState({ open: false });
    };

    returnSteps() {
        const countArray = [];
        for (let i = 1; i <= 100; i++) {
            let disable = false;
            if (this.props.aligner && this.props.aligner.length > 0) {
                disable = this.props.aligner.some((v) => v.step_no === i);
            }
            countArray.push(
                <MenuItem disabled={disable} value={i} key={i}>
                    {i}
                </MenuItem>
            );
        }
        return countArray;
    }
    handleArch(index, arch, step_no) {
        let counter_pair = 0;
        let modified_aligner = this.props.aligner.filter((v) => {
            return v.step_no === step_no;
        });
        if (modified_aligner.length > 0) {
            modified_aligner.map((v) => {
                if (v.arch === arch) {
                    counter_pair += 1;
                }
            });
        }

        if (counter_pair > 0) {
            this.setState({ open: true });
            this.props.handleChangeArch(index, '');
            this.props.handleChnageSizeAligner('', index);
        } else {
            this.props.handleChangeArch(index, arch);
        }
    }

    render() {
        return (
            <>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.get('aligner.duplicatePair')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.get('aligner.alreadyExists')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose}>{this.get(':const.close')}</Button>
                    </DialogActions>
                </Dialog>
                <Grid item xs={12} md={12}>
                    <p style={{ color: 'red', fontWeight: 'bold' }}>{this.get('msg.chargeFeeForReplacement')}</p>
                </Grid>
                {this.props.aligner.map((value, index) => (
                    <Grid container>
                        <Grid item xs={12} md={4} style={{ margin: '8px 0px' }}>
                            {/* <p style={{height:"0px",marginTop:"0",marginRight:"8px", display: "inline"}}>Replacement {index+1}</p> */}
                            <span style={{ fontWeight: 600 }}>
                                {this.get('aligner.replacement')} {index + 1}
                            </span>
                        </Grid>

                        <Grid item xs={12} md={4} style={{ margin: '8px 0px' }}>
                            <span>{this.get('aligner.stepNumber')}: </span>
                            <Select
                                style={{ width: '50%' }}
                                displayEmpty
                                value={value.step_no}
                                onChange={(e) => {
                                    this.props.handleChnageSizeAligner(e.target.value, index);
                                }}
                            >
                                {this.returnSteps()}
                            </Select>
                        </Grid>

                        <Grid item xs={12} md={4} style={{ margin: '8px 0px' }}>
                            <span>{this.get('aligner.arch')}: </span>
                            <Select
                                style={{ width: '50%' }}
                                value={value.arch}
                                displayEmpty
                                onChange={(e) => this.handleArch(index, e.target.value, value.step_no)}
                            >
                                <MenuItem value="upper" key="upper">
                                    {this.get('aligner.upper')}
                                </MenuItem>
                                <MenuItem value="lower" key="lower">
                                    {this.get('aligner.lower')}
                                </MenuItem>
                                <MenuItem value="upperAndLower" key="upperAndLower">
                                    {this.get('aligner.upperAndLower')}
                                </MenuItem>
                            </Select>
                        </Grid>

                        <Grid item xs={12}>
                            {value.remove && (
                                <Button
                                    variant="outlined"
                                    style={{ background: '#da5c5c', color: 'white', border: 'none' }}
                                    onClick={(e) => this.props.removeAligner(index, e)}
                                >
                                    {this.get('aligner.deleteThisRow')}
                                </Button>
                            )}
                        </Grid>

                        <Grid item xs={12} style={{ margin: '8px 0px' }}>
                            <hr />
                        </Grid>
                    </Grid>
                ))}
                <Grid item xs={12} md={12}>
                    <p>
                        {this.get('msg.termsAndCondChecked')}{' '}
                        <a href="/files/tc.pdf" target="_blank">
                            {this.get('msg.termsAndCondCheckedLink')}
                        </a>
                    </p>
                </Grid>
                <Button variant="outlined" onClick={() => this.props.addAligner()}>
                    {this.get('aligner.addOneMore')}
                </Button>
            </>
        );
    }
}

const mapStateToProps = (store) => ({
    lang: store.lang,
});

export default connect(mapStateToProps)(withLang(Aligner, 'PatientInfo'));
